/**
 * Cấu hình cho tính năng Tạo bài đăng tin rao vặt (Classified Ad Generator)
 * Bao gồm độ dài bài đăng và phong cách bài đăng phù hợp cho tin rao vặt
 */

// Độ dài bài đăng tin rao vặt
export const CLASSIFIED_AD_LENGTHS = [
  {
    value: "50-100 từ",
    label: "Ngắn gọn",
  },
  {
    value: "100-200 từ",
    label: "Vừa phải",
  },
  {
    value: "200-350 từ",
    label: "Đầy đủ",
  },
];

// Phong cách bài đăng tin rao vặt
export const CLASSIFIED_AD_STYLES = [
  {
    value: "Chuyên nghiệp",
    label: "Chuyên nghiệp",
  },
  {
    value: "Thân thiện",
    label: "Thân thiện",
  },
  {
    value: "Khẩn cấp",
    label: "Khẩn cấp",
  },
  {
    value: "Chi tiết",
    label: "Chi tiết",
  },
  {
    value: "Ngắn gọn súc tích",
    label: "Ngắn gọn súc tích",
  },
  {
    value: "Hấp dẫn",
    label: "Hấp dẫn",
  },
];

// Default values
export const DEFAULT_CLASSIFIED_AD_LENGTH = CLASSIFIED_AD_LENGTHS[1].value; // "Vừa phải" (100-200 từ)
export const DEFAULT_CLASSIFIED_AD_STYLES = [CLASSIFIED_AD_STYLES[0].value]; // "Chuyên nghiệp"
export const DEFAULT_USE_EMOJI = true; // Mặc định bật sử dụng emoji/icon
export const DEFAULT_USE_CONTACT_INFO = true; // Mặc định bật sử dụng thông tin liên hệ
export const DEFAULT_CONTACT_INFO = ""; // Thông tin liên hệ mặc định trống
